import { render, staticRenderFns } from "./Doc2.vue?vue&type=template&id=6d33fbf8&scoped=true&"
import script from "./Doc2.vue?vue&type=script&lang=js&"
export * from "./Doc2.vue?vue&type=script&lang=js&"
import style0 from "./Doc2.vue?vue&type=style&index=0&id=6d33fbf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d33fbf8",
  null
  
)

export default component.exports